export type CsvField = {
  label: string
  // biome-ignore lint/suspicious/noExplicitAny: `any` (not `unknown`) lets callers pass a `value` accessor typed to their own concrete row shape (e.g. `(row: GiftCardTopupRecord) => string`) instead of widening every caller to `Record<string, unknown>`
  value?: string | ((row: any) => unknown)
}

const getByPath = (obj: Record<string, unknown>, path: string): unknown => {
  return path.split('.').reduce<unknown>((acc, key) => {
    if (acc == null || typeof acc !== 'object') {
      return undefined
    }

    return (acc as Record<string, unknown>)[key]
  }, obj)
}

export const normalizeFieldsAndRows = (
  fields: CsvField[],
  rows: unknown[],
): { fields: string[]; rows: Record<string, unknown>[] } => {
  if (!fields.length) {
    return { fields: [], rows: [] }
  }
  const normalizedFields = fields.map((field) => field.label)
  const normalizedRows = rows.map((row) => {
    const sourceRow = (row ?? {}) as Record<string, unknown>

    return fields.reduce<Record<string, unknown>>((acc, field) => {
      if (!field.value) {
        acc[field.label] = sourceRow[field.label]
        return acc
      }

      if (typeof field.value === 'function') {
        acc[field.label] = field.value(sourceRow)
        return acc
      }

      acc[field.label] = getByPath(sourceRow, field.value)
      return acc
    }, {})
  })

  return { fields: normalizedFields, rows: normalizedRows }
}
